import React from "react";
import "./SearchInput.css";

const SearchInput = ({
  value,
  onChange,
  onClear,
  placeholder = "Search",
  ariaLabel = "Search",
  wrapperClassName = "",
  inputClassName = "",
  iconClassName = "",
  clearButtonClassName = "",
}) => (
  <div className={["search-input-wrap", wrapperClassName].filter(Boolean).join(" ")}>
    <i className={iconClassName} aria-hidden />
    <input
      type="search"
      className={inputClassName}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label={ariaLabel}
    />
    {value ? (
      <button type="button" className={clearButtonClassName} onClick={onClear} aria-label="Clear search">
        ×
      </button>
    ) : null}
  </div>
);

export default SearchInput;
